/**
 * FrenzyChip - the one Frenzied control (v9.5.0).
 *
 * Frenzied is a state of the combatant, synced like a condition: it gives the
 * +10 WS in melee AND blocks Dodge and Parry (Battle Rage keeps the parry),
 * and it is immune to Stun and Fatigue. It used to be two things - a
 * per-viewer cockpit switch for the bonus and a Defender-tab checkbox for the
 * block - that never met. This chip sits beside the conditions on the Status
 * tab of both panels and is the only place it is switched.
 */
import styles from '../styles/StatusBand.module.css';
import common from '../styles/common.module.css';

interface Props {
  frenzied: boolean;
  onToggle: () => void;
  locked?: boolean;
}

const TITLE =
  'Frenzied: +10 WS in melee; cannot Dodge or Parry (Battle Rage keeps the parry); immune to Stun and Fatigue.';

export function FrenzyChip({ frenzied, onToggle, locked = false }: Props) {
  return (
    <button
      type="button"
      className={[common.btnSmall, styles.chip, frenzied && styles.danger].filter(Boolean).join(' ')}
      aria-pressed={frenzied}
      title={TITLE}
      onClick={onToggle}
      disabled={locked}
      data-testid="frenzied-chip"
    >
      <span aria-hidden="true">⟲</span>
      {frenzied ? 'FRENZIED' : 'Frenzy'}
    </button>
  );
}
